const esploraBaseUrl = 'http://localhost:8094/regtest';

export default {
  bitcoin: {
    api: `${esploraBaseUrl}/api`,
    batchApi: '',
    network: 'bitcoin_regtest',
    value: 1000000,
    mineBlocks: true,
    explorer: `${esploraBaseUrl}/tx`,
  },
  basename: '/odds/app',
  oracle: {
    url: 'https://oracle.atomic.finance',
  },
  tower: {
    url: 'http://localhost:3000',
  },
  broker: {
    url: 'wss://broker.atomic.finance/',
  },
  pay: {
    url: 'http://localhost:3030'
  },
  mailchimp: {
    url: 'http://localhost:3050'
  },
  fee: '0.05'
};
